module.exports = __webpack_public_path__ + "assets/img/f82e1c5c3aff6df2ae727a555355f2f2.png";